import { createResource, type RouteResource } from 'react-resource-router';

import type { GettingStartedPanelData } from '../../common/types';
import { getGettingStartedPanelData } from '../endpoints';

export { getTeams } from '../endpoints';

export const getTeamsResource: RouteResource<never> = createResource({
	type: 'getTeamsResource',
	getKey: () => 'overview',
	getData: async () => {
		throw new Error(
			'getData of getTeamsResource is not implemented in platform package, you should do it in your product',
		);
	},
	isBrowserOnly: true,
});

export const getGettingStartedPanelResource: RouteResource<GettingStartedPanelData | null> =
	createResource<GettingStartedPanelData | null>({
		type: 'getGettingStartedPanelResource',
		getKey: () => 'overview-getting-started-panel-resource',
		getData: async () => {
			return getGettingStartedPanelData();
		},
		isBrowserOnly: true,
		maxAge: 0,
	});
